import axios from 'axios';
import { stringify } from 'query-string';
import authService from './authService';
import { getAuthHeader } from './utils/authHelper';
import { getEnv } from '../utils/envUtils';

const STATISTICS_API_URL = getEnv('REACT_APP_STATISTICS_API');

const getOrderMetaData = (orderId) => {
    const buildRequest = () => ({
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: getAuthHeader(),
        },
        url: `${STATISTICS_API_URL}/orders?${stringify({ orderId })}`,
    });

    return axios(buildRequest())
        .then(response => response.data)
        .catch(err => authService.refreshAndRetry(err, buildRequest)
            .then(response => response.data));
};

const api = {
    getOrderMetaData,
};

export default api;
